import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=13118d76&scoped=true"
import script from "./ChannelList.vue?vue&type=script&lang=js"
export * from "./ChannelList.vue?vue&type=script&lang=js"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=13118d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13118d76",
  null
  
)

export default component.exports